import React from 'react'
import { Grid, Paper, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const Card = ({ label, valor, cor, sufixo }) => (
  <Paper variant="outlined" style={{ padding: '15px 18px' }}>
    <Typography variant="caption" color="textSecondary">{label}</Typography>
    <Typography variant="h5" style={{ color: cor || '#0F3444', fontWeight: 600 }}>
      {valor}
      {sufixo && <Typography component="span" variant="caption" color="textSecondary">{` ${sufixo}`}</Typography>}
    </Typography>
  </Paper>
)

const StatCards = ({ titulos }) => {
  const { t } = useTranslation()
  const ativos = titulos.filter((x) => x.status === 'active').length
  const esgotados = titulos.filter((x) => x.status === 'exhausted').length
  const disponiveis = titulos.reduce((s, x) => s + (Number(x.quantidadeDisponivel) || 0), 0)
  const resgatados = titulos.reduce((s, x) => s + (Number(x.quantidadeResgatada) || 0), 0)

  const fmt = (n) => Number(n).toLocaleString('pt-BR', { maximumFractionDigits: 2 })

  return (
    <Grid container spacing={2} style={{ marginBottom: 8 }}>
      <Grid item xs={6} md={3}><Card label={t('titulosLbc.kpis.ativos')} valor={ativos} /></Grid>
      <Grid item xs={6} md={3}><Card label={t('titulosLbc.kpis.disponiveis')} valor={fmt(disponiveis)} cor="#219754" sufixo="LBC" /></Grid>
      <Grid item xs={6} md={3}><Card label={t('titulosLbc.kpis.resgatados')} valor={fmt(resgatados)} sufixo="LBC" /></Grid>
      <Grid item xs={6} md={3}><Card label={t('titulosLbc.kpis.esgotados')} valor={esgotados} cor="#7B65DE" /></Grid>
    </Grid>
  )
}

export default StatCards
